<template>
  <el-drawer
    ref="drawerRef"
    :title="title"
    size="55%"
    :with-header="true"
    :visible="drawer"
    v-bind="$attrs"
    :before-close="handleClosed"
    @closed="handleClosed"
  >
    <div style="padding: 5%">
      <el-descriptions class="margin-top" title="DETALLES" :column="1" border>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            CLIENTE
          </template>
          {{ data.ClientName }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-office-building"></i>
            CALIDAD DE LA PRESENTACIÓN
          </template>
          <el-rate
            v-model="data.Rate_Presentation"
            disabled="true"
            :texts="['Malo', 'Medio', 'Normal', 'Bueno', 'Excelente']"
            :colors="['#F56C6C', '#409EFF', '#67C23A']"
            show-text
          >
          </el-rate>
        </el-descriptions-item>

        <el-descriptions-item v-if="data.Rate_Presentation < 5">
          <template slot="label">
            <i class="el-icon-setting"></i>
            QUÉ DEBE MEJORAR PARA OBTENER UN 5
          </template>
          {{ data.Rate_PresentationDetail }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-folder-checked"></i>
            PRESENTÓ EL CONTRATO
          </template>
          {{ data.Contract ? "✔️" : "❌" }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-box"></i>
            PRESENTACIÓN DEL PRODUCTO
          </template>
          {{ data.Presentations_Proudct ? "✔️" : "❌" }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-edit"></i>
            OTRAS INFORMACIONES
          </template>
          {{ data.Other_Inf ? "✔️" : "❌" }}
        </el-descriptions-item>

        <el-descriptions-item v-if="data.Other_Inf">
          <template slot="label">
            <i class="el-icon-tickets"></i>
            DETALLES DE LAS OTRAS INFORMACIONES
          </template>
          {{ data.Other_InfDetail }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-document-copy"></i>
            INFORMACIONES QUE LE HACE FALTA AL CLIENTE
          </template>
          {{ data.Infot_MissingClient }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-date"></i>
            FECHA DE COTIZACIÓN
          </template>
          {{ Date_QuotationFormatter }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-date"></i>
            FECHA DE COMPRA
          </template>
          {{ Date_PurchaseFormatter }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </el-drawer>
</template>

<script>
import { formatDate } from "@/utils";

export default {
  name: "DealsPresentationDescription",
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      Date_PurchaseFormatter: "",
      Date_QuotationFormatter: "",
      princeFormatter: "",
      title: "DETALLES DE LA PRESENTACIÓN AL CLIENTE",
      presentationValuation: 5
    };
  },
  methods: {
    formatterData(Date_Quotation, Date_Purchase) {
      this.Date_QuotationFormatter = formatDate(Date_Quotation, "DD/MM/YYYY");
      this.Date_PurchaseFormatter = formatDate(Date_Purchase, "DD/MM/YYYY");
    },
    handleClosed() {
      this.$emit("close-drawer");
    }
  }
};
</script>
